<template>
    <div class="wrapJ">
        <!--头部-->
        <div class="headerJ">
            <div class="headerLeftJ">
                <div class="leftJtop">
                    <span class="iconfont">&#xe6b0;</span>
                    <span>我的积分</span>
                </div>
                <div v-if="$store.state.hasLogin" class="leftJbottom">
                    <p>年度积分：{{ myJfData.credit }}</p>
                    <p>可兑换积分：{{ myJfData.totalCredit }}</p>
                    <p>已兑换积分：{{ myJfData.usedcredit!=null?myJfData.usedcredit:0 }}</p>
                </div>
                <div
                    v-if="!$store.state.hasLogin"
                    class="not-login"
                    @click="goLogin"
                >
                    请登录
                </div>
            </div>
            <div class="headerRightJ">
                <img src="static/img/jfsc.jpg" />
            </div>
        </div>
        <!--内容-->
        <div class="box-title">热门兑换</div>
        <div class="contentJ flex-row">
            <div class="boxJ" v-for="(item, index) in hotData" :key="index">
                <div class="imgJ">
                    <img class="bg" :src="item.productImage" alt="" />
                </div>
                <div class="textJ">
                    {{
                        item.productName.length > 30
                            ? item.productName.substring(0, 30) + "..."
                            : item.productName
                    }}
                </div>
                <div class="priceJ">
                    参考价<s>:￥{{ item.price }}</s>
                </div>
                <div class="scoreJ flex-row">
                    <span class="scoreLeftJ"
                        >{{ item.accumulatePoints }}积分</span
                    >
                    <span class="scoreRightJ" @click="duihuan(item)"
                        >立即兑换</span
                    >
                </div>
            </div>
        </div>
        <!-- 五谷杂粮 -->
        <!--<div class="box-title">五谷杂粮</div>
        <div class="contentJ flex-row">
            <div class="boxJ" v-for="(item, index) in wuguData" :key="index">
                <div class="imgJ">
                    <img class="bg" :src="item.productImage" alt="" />
                </div>
                <div class="textJ">{{ item.productName }}</div>
                <div class="priceJ">
                    参考价<s>:￥{{ item.price }}</s>
                </div>
                <div class="scoreJ flex-row">
                    <span class="scoreLeftJ"
                        >{{ item.accumulatePoints }}积分</span
                    >
                    <span class="scoreRightJ" @click="duihuan(item)"
                        >立即兑换</span
                    >
                </div>
            </div>
        </div>-->

        <!--弹出框 确认兑换-->
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div v-show="ensureFlag" class="alertBoxOne animated">
                <div class="iconfont close" @click="ensureFlag = false">
                    &#xe66f;
                </div>
                <div class="oneTitle">兑换确认</div>
                <div class="oneDetail">
                    <div class="detailName flex-row">
                        <span class="detailSpan">商品名称：</span>
                        <div class="detailDiv">
                            {{ ensureData.productName }}
                        </div>
                    </div>
                    <div class="priceDiv flex-row">
                        <span class="priceSpan"
                            >参考价:￥<s>{{ ensureData.price }}</s></span
                        >
                        <div class="jf">
                            兑换积分：<span class="jfSpan"
                                >{{ ensureData.accumulatePoints }}积分</span
                            >
                        </div>
                    </div>
                </div>
                <div class="btnOne flex-row">
                    <div class="sure" @click="ensureDuihuan(ensureData.id)">
                        确认
                    </div>
                    <div class="cancel" @click="ensureFlag = false">取消</div>
                </div>
            </div>
        </transition>
        <!-- 兑换成功 -->
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div v-show="successFlag" class="alertBoxTwo animated">
                <div class="iconfont close" @click="successFlag = false">
                    &#xe66f;
                </div>
                <div class="twoTitle">
                    <div class="iconfont sucess">&#xe605;</div>
                    <div class="sucessText">兑换成功</div>
                </div>
                <div class="oneDetail flex-row">
                    <div class="first">
                        已生成兑换号码：{{ successData.exchangeCode }}
                    </div>
                    <div class="second">
                        兑换开始日期：{{
                            successData.createTime &&
                                successData.createTime.time | dateFormat
                        }}
                    </div>
                    <div class="third">
                        兑换地址：{{ successData.receiveAdress }}
                    </div>
                </div>
                <div class="btnTwo flex-row">
                    <div @click="goOrderList" class="see">查看积分订单</div>
                    <div class="return" @click="successFlag = false">
                        返回积分商城
                    </div>
                </div>
            </div>
        </transition>
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div v-show="errorFlag" class="error-box animated">
                <div class="iconfont close" @click="errorFlag = false">
                    &#xe66f;
                </div>
                <div class="error-title flex-row">
                    <span class="iconfont">&#xe66f;</span>
                    <span class="title-text">错误信息：</span>
                </div>
                <div class="error-detail">
                    <span>{{ errorText }}</span>
                </div>
            </div>
        </transition>
        <div
            v-show="successFlag || ensureFlag || errorFlag"
            class="jf-mask"
        ></div>
        <transition enter-active-class="fadeIn" leave-active-class="fadeOut">
            <div v-show="pendingTag" class="eazy-toast animated">
                {{ pendingText }}
            </div>
        </transition>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "jfsc",
    data() {
        return {
            successFlag: false,
            ensureFlag: false,
            errorFlag: false,
            hotData: [],
            wuguData: [],
            ensureData: {},
            successData: {},
            errorText: "",
            pendingTag: false,
            pendingText: "",
            timmer: null,
            exchangePending: false,
            myJfData: {}
        };
    },
    created() {
        this.getHot(1);
        this.getHot(2);
        if (this.$store.state.hasLogin) {
            this.getMyJf();
        }
    },
    methods: {
        showSuccess() {
            this.successFlag = true;
        },
        showEnsure() {
            this.ensureFlag = true;
        },
        duihuan(item) {
            if (!this.$store.state.hasLogin) {
                this.$router.push({
                    name: "login"
                });
                return;
            }
            this.ensureData = item;
            this.ensureFlag = true;
        },
        ensureDuihuan(id) {
            this.goExchange(id);
        },
        goOrderList() {
            this.$router.push({
                name: "grzx",
                query: {
                    type: 2
                }
            });
        },
        getHot(type) {
            this.$ajax({
                mothod: "post",
                url: "homePage/myProduct",
                data: {
                    type: type
                },
                success: res => {
                    if (res.code == 200) {
                        if (type == 1) {
                            this.hotData = res.message;
                        } else {
                            this.wuguData = res.message;
                        }
                    }
                },
                error: res => {}
            });
        },
        goLogin() {
            this.$router.push({
                name: "login"
            });
        },
        getMyJf() {
            this.$ajax({
                method: "post",
                url: "homePage/myCredit",
                data: {
                    token: this.$store.state.userToken
                },
                success: res => {
                    if (res.code == 200) {
                        this.myJfData = res.message;
                    }
                    this.exchangePending = false;
                },
                error: () => {}
            });
        },
        goExchange(id) {
            if (this.exchangePending) {
                this.pendingText = "正在兑换";
                this.pendingTag = true;
                return;
            }
            this.exchangePending = true;
            this.$ajax({
                method: "post",
                url: "homePage/exchange",
                data: {
                    token: this.$store.state.userToken,
                    productId: id
                },
                success: res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.ensureFlag = false;
                        this.successData = res.message;
                        this.successFlag = true;
                        this.getMyJf();
                    } else {
                        this.ensureFlag = false;
                        this.errorText = res.message;
                        this.errorFlag = true;
                    }
                    this.exchangePending = false;
                },
                error: () => {}
            });
        }
    },
    watch: {
        pendingTag: function(nval) {
            if (nval) {
                clearTimeout(this.timmer);
                this.timmer = null;

                this.timmer = setTimeout(() => {
                    this.pendingTag = false;
                    clearTimeout(this.timmer);
                    this.timmer = null;
                }, 2000);
            }
        }
    }
};
</script>
<style scoped="scoped" lang="scss">
.box-title {
    font-size: 18px;
    color: #595959;
    font-weight: bold;
    line-height: 30px;
    margin-top: 15px;
    border-bottom: 2px solid #ddd;
    position: relative;
}
.box-title::after {
    content: "";
    height: 2px;
    width: 80px;
    background-color: #6ac0e8;
    position: absolute;
    bottom: -2px;
    left: 0;
}
.wrapJ {
    width: 1000px;
    min-height: 500px;
    overflow: hidden;
    margin: 0 auto;
}

.headerJ {
    width: 1000px;
    height: 240px;
    box-sizing: border-box;
}

.headerLeftJ {
    float: left;
    width: 300px;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #ddd;
    text-align: center;
    border-radius: 4px;
}

.headerRightJ {
    float: right;
    width: 690px;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
    }
}

.leftJtop {
    padding: 20px 0;
    width: 80%;
    margin: 0 auto;
    text-align: left;
    border-bottom: 1px solid #ddd;
    .iconfont {
        font-size: 25px;
        color: #ffca00;
        vertical-align: middle;
        margin-right: 10px;
    }
    span {
        vertical-align: middle;
    }
}

.not-login {
    color: #fff;
    width: 50px;
    padding: 7px 20px;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 40px;
    background-color: #99cc33;
    box-shadow: 0 0 15px #99cc33;
    transition: all ease 0.2s;
    cursor: pointer;
}

.not-login:hover {
    box-shadow: 0 0 15px #006633;
}

.leftJbottom {
    padding: 20px;
    padding-top: 60px;
    width: 80%;
    text-align: left;
    margin: 0 auto;
}

.boxJ:nth-child(4n) {
    margin-right: 0;
}
.boxJ {
    width: 242px;
    margin-right: 10px;
    margin-top: 20px;
    box-sizing: border-box;
    display: inline-block;
    vertical-align: top;
    .textJ {
        max-height: 40px;
        width: 100%;
        overflow: hidden;
        line-height: 20px;
    }
}

.imgJ {
    width: 100%;
    height: 164.9px;
    display: inline-block;
    vertical-align: top;
    border: 1px solid #ddd;
    overflow: hidden;
    img {
        width: 100%;
        min-height: 100%;
    }
}

.scoreJ {
    height: 27px;
    line-height: 27px;
    widows: 100%;
    justify-content: space-between;
    .scoreRightJ {
        border-radius: 4px;
        padding: 0 5px;
        height: 25px;
        line-height: 25px;
        border: solid 1px #aaa;
        cursor: pointer;
    }
    .scoreRightJ:hover {
        background-color: #ededed;
    }
}

.scoreLeftJ {
    color: #6ac0e8;
}

.contentJ {
    width: 1000px;
    align-items: flex-start;
    align-content: flex-start;
    padding-bottom: 10px;
}
/* 弹窗 */
.alertBoxOne {
    width: 500px;
    background-color: #ffffff;
    border-radius: 4px;
    position: fixed;
    top: 50%;
    margin-top: -200px;
    margin-left: 50%;
    left: -250px;
    padding: 20px 0;
    border: solid 1px rgba(228, 235, 241, 0.5);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.7);
    z-index: 110;
    color: #969696;
    .close {
        color: #666;
        position: absolute;
        font-size: 25px;
        top: 5px;
        right: 5px;
        cursor: default;
    }
    .close:hover {
        color: #000;
    }
    .oneTitle {
        padding: 10px 40px;
    }
    .oneDetail {
        background-color: #f2f2f2;
        padding: 10px 40px;
        .detailName {
            overflow: hidden;
            align-items: flex-start;
            padding: 10px 0;
            .detailSpan {
                float: left;
                width: 80px;
            }
            .detailDiv {
                float: right;
                flex: 1;
            }
        }
    }
    .priceDiv {
        padding: 10px 0;
        justify-content: space-between;
        .jfSpan {
            color: #000;
        }
    }
    .btnOne {
        margin-top: 10px;
        justify-content: space-between;
        .sure {
            width: 200px;
            height: 35px;
            text-align: center;
            line-height: 35px;
            background-color: #6ac0e8;
            color: white;
            border: 1px solid gainsboro;
            margin-left: 40px;
            cursor: default;
            transition: all ease 0.2s;
            display: inline-block;
            vertical-align: middle;
        }
        .sure:hover {
            border-color: #999;
        }
        .cancel:hover {
            color: #000;
            border-color: #999;
        }
        .cancel {
            width: 200px;
            height: 35px;
            display: inline-block;
            vertical-align: middle;
            border: solid 1px #a6a6a6;
            text-align: center;
            line-height: 35px;
            background-color: white;
            color: gray;
            border: 1px solid gainsboro;
            margin-right: 40px;
            cursor: default;
            transition: all ease 0.2s;
        }
    }
}
// 查看弹窗
.alertBoxTwo {
    width: 500px;
    background-color: #ffffff;
    border-radius: 4px;
    position: fixed;
    top: 50%;
    margin-top: -200px;
    z-index: 110;
    margin-left: 50%;
    left: -250px;
    padding: 20px 0;
    border: solid 1px rgba(228, 235, 241, 0.5);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    color: #969696;
    .close {
        color: #666;
        position: absolute;
        font-size: 25px;
        top: 5px;
        right: 5px;
        cursor: default;
    }
    .close:hover {
        color: #000;
    }
    .twoTitle {
        text-align: center;
        margin-bottom: 10px;
        .sucess {
            font-size: 60px;
            color: #ffca00;
        }
        .sucessText {
            color: #969696;
        }
    }
    .oneTitle {
        padding: 10px 40px;
    }
    .oneDetail {
        background-color: #f2f2f2;
        padding: 10px 40px;
        .detailName {
            overflow: hidden;
            align-items: flex-start;
            padding: 10px 0;
            .detailSpan {
                float: left;
                width: 80px;
            }
            .detailDiv {
                float: right;
                flex: 1;
            }
        }
    }
    .priceDiv {
        padding: 10px 0;
        justify-content: space-between;
    }
    .btnTwo {
        margin-top: 10px;
        justify-content: space-between;
        .see {
            display: inline-block;
            vertical-align: middle;
            width: 200px;
            height: 35px;
            text-align: center;
            line-height: 35px;
            background-color: #6ac0e8;
            color: white;
            border: 1px solid gainsboro;
            margin-left: 40px;
            cursor: default;
            transition: all ease 0.2s;
        }
        .sure:hover {
            border-color: #999;
        }
        .return:hover {
            color: #000;
            border-color: #999;
        }
        .return {
            display: inline-block;
            vertical-align: middle;
            width: 200px;
            height: 35px;
            border: solid 1px #a6a6a6;
            text-align: center;
            line-height: 35px;
            background-color: white;
            color: gray;
            border: 1px solid gainsboro;
            margin-right: 40px;
            cursor: default;
            transition: all ease 0.2s;
        }
    }
}
.error-box {
    width: 500px;
    background-color: #ffffff;
    border-radius: 4px;
    position: fixed;
    top: 50%;
    margin-top: -200px;
    z-index: 110;
    margin-left: 50%;
    left: -250px;
    padding: 20px 0;
    border: solid 1px rgba(228, 235, 241, 0.5);
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
    color: #969696;
    .close {
        color: #666;
        position: absolute;
        font-size: 25px;
        top: 5px;
        right: 5px;
        cursor: default;
    }
    .close:hover {
        color: #000;
    }
    .error-title {
        height: 30px;
        align-items: center;
        padding: 20px 20px 0 20px;
        span {
            font-size: 18px;
            color: #000;
            vertical-align: middle;
            line-height: 30px;
        }
        .iconfont {
            color: red;
            line-height: 30px;
            font-size: 30px;
            padding-right: 10px;
        }
    }
    .error-detail {
        margin: 10px 0;
        padding: 20px;
        background-color: #f2f2f2;
    }
}
.jf-mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 100;
}
.eazy-toast {
    height: 50px;
    width: 80px;
    border-radius: 25px;
    line-height: 50px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 999;
    top: 400px;
    margin-left: 50%;
    left: -70px;
    background-color: rgba(0, 0, 0, 0.9);
    color: #fff;
    text-align: center;
    padding: 0 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/jfsc/jfsc.vue